// 261010 UI1a + U32b — thanh 7 ô bước (Prompt & Video là MỘT ô; không còn ô Ghép; không cuộn ngang ở ≥1280px) + dải đoạn màu từng video. Chữ trạng thái từ `stepBadgeOf` (thuần).
import React from 'react';
import type { WorkflowStatus, WorkflowStepKey } from '../../types/filmWorkflow';
import { BOARD_STEPS } from './workflowBoardUtils';
import { stepBadgeOf, stepSegmentsOf } from './workflowPrimaryPolicy';
import StatusIcon, { IconChip } from './StatusIcon';

interface Props {
  status: WorkflowStatus;
  selected: WorkflowStepKey;
  onSelect: (key: WorkflowStepKey) => void;
}

const WorkflowStepsBar: React.FC<Props> = ({ status, selected, onSelect }) => (
  <nav className="wf-steps wf-steps7" aria-label="7 bước của plan">
    {BOARD_STEPS.map((m) => {
      const on = selected === m.key;
      const badge = stepBadgeOf(status, m.key);
      const segs = stepSegmentsOf(status, m.key);
      const sum = status.steps.find((x) => x.key === m.key);
      return (
        <button key={m.key} type="button" className={`wf-stp${on ? ' on' : ''}`} aria-pressed={on} onClick={() => onSelect(m.key)} data-testid={`wf-stp-${m.key}`}>
          <span className="wf-stp-top"><span className="wf-stp-n">{m.no}</span><span className="wf-stp-name" title={m.name}>{m.name}</span></span>
          <span className="wf-stp-sub">
            <StatusIcon text={badge.text} tone={badge.tone} testId={`wf-stp-st-${m.key}`} focusable={false} />
          </span>
          {segs.length > 0 ? (
            <span className="wf-seg">{segs.map((g) => <i key={g.eventId} className={g.tone} title={g.label} aria-label={g.label} />)}</span>
          ) : null}
        </button>
      );
    })}
  </nav>
);

export default WorkflowStepsBar;
